import React from 'react';
import { useFormikContext } from 'formik';
import { Row, Col } from 'reactstrap';
import { Field } from '@cordata/buffet';

const businessDaysModeOptions = [
  {
    label: 'None',
    value: 'none',
  },
  {
    label: 'Pre-calculated column',
    value: 'preCalculated',
  },
  {
    label: 'Calculate automatically',
    value: 'calculate',
  },
];

const LagCalculationForm = ({
  lagTableIndex,
  lagCalcIndex,
  columnOptions,
}) => {
  const { values } = useFormikContext();

  const lagCalc = values.lagTables?.[lagTableIndex]?.lagCalculations?.[lagCalcIndex];

  return (
    <>
      <Row form>
        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.lagCalculations.${lagCalcIndex}.label`}
            label="Label"
            text="Display name for this lag calculation (e.g., 'Referral to Intake')"
            required
          />
        </Col>

        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.lagCalculations.${lagCalcIndex}.startDateColumn`}
            label="Start Date Column"
            text="The 'from' date column"
            type="select"
            options={columnOptions}
            required
          />
        </Col>

        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.lagCalculations.${lagCalcIndex}.endDateColumn`}
            label="End Date Column"
            text="The 'to' date column"
            type="select"
            options={columnOptions}
            required
          />
        </Col>
      </Row>

      <Row form>
        <Col sm={4}>
          <Field
            name={`lagTables.${lagTableIndex}.lagCalculations.${lagCalcIndex}.businessDaysMode`}
            label="Business Days"
            text="How to handle business days calculation"
            type="select"
            options={businessDaysModeOptions}
          />
        </Col>

        {lagCalc?.businessDaysMode?.value === 'preCalculated' && (
          <Col sm={4}>
            <Field
              name={`lagTables.${lagTableIndex}.lagCalculations.${lagCalcIndex}.businessDaysColumn`}
              label="Business Days Column"
              text="Column containing pre-calculated business days"
              type="select"
              options={columnOptions}
              required
            />
          </Col>
        )}

        {lagCalc?.businessDaysMode?.value === 'calculate' && (
          <Col sm={8}>
            <div className="alert alert-info mt-4">
              Business days will be calculated client-side. This excludes weekends but does not account for holidays.
            </div>
          </Col>
        )}
      </Row>
    </>
  );
};

export default LagCalculationForm;
